import React__default from 'react';
import { Callout } from '@vp/swan';

const SelectionSetTileCallouts = ({ callouts }) => {
    return (React__default.createElement(React__default.Fragment, null, callouts?.map((callout) => {
        return (React__default.createElement(Callout, { key: callout.key, skin: callout.style ?? "accent", emphasis: "low" }, callout.text));
    })));
};

export { SelectionSetTileCallouts };
//# sourceMappingURL=callouts.mjs.map
